/* istanbul ignore file */

import { getPadraoComRetorno, postPadraoComRetorno, putPadraoComRetorno, deletePadrao } from 'services/api';
import { montarUrlFiltro } from 'utils/funcaoPadrao';
import { duckTodosSetoresListar, duckSetorDetalhar } from 'store/ducks/setor';
import { duckInputSelectOptionsSetores } from 'store/ducks/inputs';
import { setorSistemaDetalhar } from 'routes/paths';

export const fetchBuscarSetores = (isSetoresPersonalizados = true) => dispatch => {
  return new Promise(resolve => {
    const url = `Setores?flSetorPersonalizado=${isSetoresPersonalizados}`;
    dispatch(getPadraoComRetorno(url)).then(res => {
      dispatch(duckInputSelectOptionsSetores(res));
      resolve(res);
    });
  });
};

export const fetchSalvarNovoSetor = setor => dispatch => {
  return new Promise(resolve => {
    const url = `Setores`;
    dispatch(postPadraoComRetorno(url, setor)).then(res => resolve(res));
  });
};

export const fetchSalvarSetorEditado = setor => dispatch => {
  return new Promise(resolve => {
    const url = `Setores`;
    dispatch(putPadraoComRetorno(url, setor)).then(res => resolve(res));
  });
};

export const fetchGetSetoresByFilter = (filtro, page, itemsByPage) => dispatch => {
  const url = montarUrlFiltro(`Setores/page=${page}&itemsByPage=${itemsByPage}`, filtro);
  dispatch(duckTodosSetoresListar({ list: [] }));
  dispatch(getPadraoComRetorno(url, true)).then(res => {
    dispatch(duckTodosSetoresListar(res));
  });
};

export const fetchDetalharSetorPorId = (id, history) => dispatch => {
  const url = `Setores/${id}`;
  return new Promise(resolve => {
    dispatch(getPadraoComRetorno(url)).then(retorno => {
      dispatch(duckSetorDetalhar(retorno));
      if (history) history.push(setorSistemaDetalhar);
      resolve(retorno);
    });
  });
};

export const fetchDeletarSetor = id => dispatch => {
  const url = `Setores/${id}`;
  return new Promise((resolve, reject) => {
    dispatch(deletePadrao(url, () => {}))
      .then(res => resolve(res))
      .catch(erro => reject(erro));
  });
};
